import React from "react";
import PropTypes from "prop-types";

import propTypes from "../../../../../../constants/propTypes";
import ScaleForm from "../ScaleForm";

export const EditScale = ({ scale, handleEditScale, closeModalDialog }) => {
  return (
    <ScaleForm
      initialValues={{ name: scale.name }}
      onSubmit={handleEditScale}
      onCancel={closeModalDialog}
      sendButtonText="Save"
    />
  );
};

EditScale.propTypes = {
  scale: propTypes.scale.isRequired,
  handleEditScale: PropTypes.func.isRequired,
  closeModalDialog: PropTypes.func.isRequired,
};
